import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsCL: CultureInfo = {
  name: 'es-CL',
  displayName: 'Spanish (Chile)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-CL',
  parent: CultureInfoEs
};
